module.exports = __webpack_public_path__ + "static/media/00-main01-sp_4x.63d7d058.png";